var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.979.41a1.48 1.48 0 012.043 0l.015.014C12.822 2.202 14.91 3.1 17.61 3.255c1.295.074 2.325 1.169 2.344 2.492.004.272.01.516.021.746v.019c.053 2.819.118 6.327-1.033 9.515-.63 1.749-1.585 3.268-2.837 4.518-1.425 1.422-3.291 2.552-5.547 3.358A1.69 1.69 0 0110 24a1.653 1.653 0 01-.558-.097C7.184 23.1 5.316 21.97 3.89 20.547c-1.253-1.249-2.207-2.768-2.838-4.516C-.094 12.852-.029 9.35.023 6.537l.002-.044c.01-.232.017-.476.02-.745.02-1.324 1.05-2.419 2.344-2.492C5.09 3.1 7.18 2.202 8.964.424zm1.02 5.61c-3.227 0-5.852 2.682-5.852 5.98 0 3.298 2.625 5.982 5.853 5.982 3.227 0 5.853-2.684 5.853-5.982S13.227 6.02 10 6.02zm0 1.408c2.468 0 4.476 2.051 4.476 4.572 0 2.522-2.008 4.573-4.475 4.573-2.468 0-4.475-2.051-4.475-4.573 0-2.521 2.007-4.572 4.475-4.572zm2.658 2.716a.679.679 0 00-.975 0l-2.719 2.778-.737-.754a.679.679 0 00-.975 0 .715.715 0 000 .995l1.225 1.252a.679.679 0 00.975 0l3.206-3.276a.715.715 0 000-.995z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverage);
export default ForwardRef;